module.exports = __webpack_public_path__ + "img/pattern-lines.92084943.svg";